module.exports = __webpack_public_path__ + "img/in.in1434165.svg";